import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import AuthenticationComponent from "./Authentication";
import DashboardComponent from "./Dashboard";
import ApplicationLoaderComponent from "../components/ApplicationLoader";
import { verifyAuthentication } from "../actions/authActions";
import { Route, Routes } from "react-router-dom";

import CommonUIComponent from "../components/CommonUI";
import User from "./User";
import Home from "./Home";
import Domains from "./Domains";
import Fax from "./Fax/SendFax";
import Reports from "./Reports";
import Administrators from "./Administrators";
import Forms from "./Forms";
import Eins from "./Eins";
import GetFax from "./Fax/GetFax";
import GenerateReport from "./GenerateReport";
import DomainAdmin from "./Domains/Admin";
import BulkActions from "./BulkActions";
import Analytics from "./Analytics";
import DomainSsoConfiguration from "./SsoConfiguration";

class RootContainer extends Component {
  componentWillMount() {
    this.props.verifyAuthentication();
  }
  render() {
    return (
      <div>
        {this.props.authenticating && <ApplicationLoaderComponent />}
        {!this.props.authenticating && !this.props.logged && (
          <div className="app">
            <AuthenticationComponent />
          </div>
        )}
        {this.props.logged && (
          <div className="app">
            <DashboardComponent />

            {this.props.logged && (
              <Routes>
                <Route
                  path="/users/p/:sort/:page/:status?/:search?"
                  exact
                  element={<Home />}
                />
                <Route path="/users/:id/:tab?" exact element={<User />} />
                <Route path="/" exact element={<Home />} />
                <Route path="/forms" exact element={<Forms />} />
                <Route path="/cfp" exact element={<GenerateReport />} />
                {this.props.auth.account.super && [
                  <Route path="/domains" exact element={<Domains />} />,
                  <Route path="/accounts" exact element={<Administrators />} />,
                  <Route
                    path="/upload-ein/:domainId"
                    exact
                    element={<Eins />}
                  />,
                  <Route
                    path="/domain/:domainId/admin-page"
                    exact
                    element={<DomainAdmin />}
                  />,
                  <Route
                    path="/domain/:domainId/sso-configuration"
                    exact
                    element={<DomainSsoConfiguration />}
                  />,
                ]}
                {this.props.auth.account.super && [
                  <Route path="/send/fax" exact element={<Fax />} />,
                ]}
                {this.props.auth.account.super && [
                  <Route path="/fax" exact element={<GetFax />} />,
                ]}
                {this.props.auth.account.super && [
                  <Route path="/reports" exact element={<Reports />} />,
                ]}
                {this.props.auth.account.super && <Route element={<Home />} />}
                {this.props.auth.account.super && (
                  <Route path="/bulk-actions" element={<BulkActions />} />
                )}
                {this.props.auth.account.super && (
                  <Route path="/analytics" element={<Analytics />} />
                )}
              </Routes>
            )}
          </div>
        )}

        <CommonUIComponent />
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    logged: state.auth.logged,
    authenticating: state.auth.authenticating,
    verifyAuthentication: verifyAuthentication,
  };
};

RootContainer.propTypes = {
  logged: PropTypes.bool,
  authenticating: PropTypes.bool,
  verifyAuthentication: PropTypes.func.isRequired,
};
export default connect(mapStateToProps, { verifyAuthentication })(
  RootContainer,
);
